import { cn } from '@/lib/utils'

interface LoadingProps {
  variant?: 'default' | 'fullscreen'
  message?: string
}

export default function Loading({
  variant = 'default',
  message = 'Loading, please wait...',
  className,
  ...props
}: LoadingProps & React.ComponentProps<'svg'>) {
  // The icon is licensed under MIT License.
  // Both commercial and personal use is permitted. No attribution is required.
  // https://magecdn.com/tools/svg-loaders/3-dots-bounce/
  const icon = (
    <svg
      className={cn(
        'fill-primary',
        variant === 'fullscreen' ? undefined : className,
        variant === 'fullscreen' ? 'h-18 w-18' : 'h-12 w-12'
      )}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="4" cy="12" r="3">
        <animate
          id="spinner_qFRN"
          begin="0;spinner_OcgL.end+0.25s"
          attributeName="cy"
          calcMode="spline"
          dur="0.6s"
          values="12;6;12"
          keySplines=".33,.66,.66,1;.33,0,.66,.33"
        />
      </circle>
      <circle cx="12" cy="12" r="3" className="fill-secondary">
        <animate
          begin="spinner_qFRN.begin+0.1s"
          attributeName="cy"
          calcMode="spline"
          dur="0.6s"
          values="12;6;12"
          keySplines=".33,.66,.66,1;.33,0,.66,.33"
        />
      </circle>
      <circle cx="20" cy="12" r="3">
        <animate
          id="spinner_OcgL"
          begin="spinner_qFRN.begin+0.2s"
          attributeName="cy"
          calcMode="spline"
          dur="0.6s"
          values="12;6;12"
          keySplines=".33,.66,.66,1;.33,0,.66,.33"
        />
      </circle>
    </svg>
  )

  return variant === 'fullscreen' ? (
    <div
      className={cn(
        'flex flex-1 flex-col items-center justify-center',
        className
      )}
    >
      {icon}
      <h3 className="text-muted-foreground text-xl font-light">{message}</h3>
    </div>
  ) : (
    <div className={cn('flex items-center gap-2', className)}>
      {icon}
      <span className="text-muted-foreground">{message}</span>
    </div>
  )
}
